// SSP reducer to handle blog/related articles enrichment
import { Cookies } from 'react-cookie';
import { getConfig } from '@belong/configs/next/config';
import { getContentfulSettings } from '@belong/contentful';
import { SectionParser } from '@belong/contentful/factories';
import type { TSSPChain } from '@belong/ssp-execution';
import { Entry, IArticleBlog, IContentfulSettings } from '@belong/types';
import { doesPageLinkToBlogArticle, FArticleBlog } from '../contentful/factories/ArticleBlog';
import { getParsedSection, getRelatedArticles } from '../helpers/contentful';
import { TPublicSSPContext } from './types';

export interface IBlogArticlesEnrichmentProps {
  parsedPageEntry: Entry<any>;
  contentfulSettings: IContentfulSettings;
  getParsedSection: SectionParser;
}
export interface IBlogArticlesEnrichmentResponse {
  blogArticle: IArticleBlog | undefined;
  relatedArticles: Entry<any>[];
}

const blogArticlesEnrichment = async ({
  parsedPageEntry,
  contentfulSettings,
  getParsedSection: sectionParser
}: IBlogArticlesEnrichmentProps): Promise<IBlogArticlesEnrichmentResponse> => {
  let blogArticle: IArticleBlog | undefined;
  let relatedArticles: Entry<any>[] = [];

  if (doesPageLinkToBlogArticle(parsedPageEntry)) {
    const articleData: Entry<any> = parsedPageEntry?.fields.page ?? parsedPageEntry?.fields.blogArticle;
    blogArticle = await FArticleBlog(articleData, sectionParser);
    relatedArticles = await getRelatedArticles(parsedPageEntry, contentfulSettings);
  }

  return { blogArticle, relatedArticles };
};

export const blogArticlesSSP: TSSPChain<TPublicSSPContext> = async ctx => {
  const contentfulSettings = getContentfulSettings(
    new Cookies(ctx.context.req?.headers.cookie),
    getConfig().publicRuntimeConfig.contentful
  );

  if (!ctx.pageEntry) {
    return ctx;
  }

  const { blogArticle, relatedArticles } = await blogArticlesEnrichment({
    parsedPageEntry: ctx.pageEntry,
    contentfulSettings,
    getParsedSection
  });

  return { ...ctx, blogArticle, relatedArticles };
};
